import { UPDATED_FLOWCODE_COLOR_OPTIONS } from '../../constants/flowcode'

export const isPredefinedColorChipColor = (hexColor: string): boolean => {
  const found = UPDATED_FLOWCODE_COLOR_OPTIONS.find(
    colorObj => colorObj.color.toUpperCase() === hexColor.toUpperCase()
  )
  return Boolean(found)
}
